export const CONTRACT_LIST = 'CONTRACT_LIST';
export const BASIC_INFO = 'BASIC_INFO';
export const ADD_CONTR = 'ADD_CONTR';
export const CONTRACT_LIST_LOADER = 'CONTRACT_LIST_LOADER';
export const CTR_SHORT_INFO = 'CTR_SHORT_INFO';
export const CONTRACT_USAGE_INFO = 'CONTRACT_USAGE_INFO';
